import { render, staticRenderFns } from "./loginFooter.vue?vue&type=template&id=5bf10eb3"
import script from "./loginFooter.vue?vue&type=script&lang=js"
export * from "./loginFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports